/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIResponseBase,
  GDPRConsentLevel,
  GDPRConsentRequest,
  GetConsentGdpr200Response,
  PutConsentGdpr200Response,
} from '../models';
import {
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
    GDPRConsentLevelFromJSON,
    GDPRConsentLevelToJSON,
    GDPRConsentRequestFromJSON,
    GDPRConsentRequestToJSON,
    GetConsentGdpr200ResponseFromJSON,
    GetConsentGdpr200ResponseToJSON,
    PutConsentGdpr200ResponseFromJSON,
    PutConsentGdpr200ResponseToJSON,
} from '../models';

export interface DeleteConsentGdprRequest {
    slashIDSdkVersion?: string;
    consentLevels?: Array<GDPRConsentLevel>;
    deleteAll?: boolean;
}

export interface GetConsentGdprRequest {
    slashIDSdkVersion?: string;
}

export interface PostConsentGdprRequest {
    gDPRConsentRequest: GDPRConsentRequest;
    slashIDSdkVersion?: string;
}

export interface PutConsentGdprRequest {
    gDPRConsentRequest: GDPRConsentRequest;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class PersonConsentsApi extends runtime.BaseAPI {

    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */
    async deleteConsentGdprRaw(requestParameters: DeleteConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.consentLevels) {
            queryParameters['consent_levels'] = requestParameters.consentLevels;
        }

        if (requestParameters.deleteAll !== undefined) {
            queryParameters['deleteAll'] = requestParameters.deleteAll;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes the specified GDPR consent, or all consents.
     * Remove GDPR consent of current user
     */
    async deleteConsentGdpr(requestParameters: DeleteConsentGdprRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConsentGdprRaw(requestParameters, initOverrides);
    }

    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */
    async getConsentGdprRaw(requestParameters: GetConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetConsentGdpr200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConsentGdpr200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns the GDPR consent levels and timestamp for current person, if it exists. 
     * Get GDPR consent of current user
     */
    async getConsentGdpr(requestParameters: GetConsentGdprRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetConsentGdpr200Response> {
        const response = await this.getConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */
    async postConsentGdprRaw(requestParameters: PostConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutConsentGdpr200Response>> {
        if (requestParameters.gDPRConsentRequest === null || requestParameters.gDPRConsentRequest === undefined) {
            throw new runtime.RequiredError('gDPRConsentRequest','Required parameter requestParameters.gDPRConsentRequest was null or undefined when calling postConsentGdpr.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GDPRConsentRequestToJSON(requestParameters.gDPRConsentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutConsentGdpr200ResponseFromJSON(jsonValue));
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Store GDPR consent of current user
     */
    async postConsentGdpr(requestParameters: PostConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutConsentGdpr200Response> {
        const response = await this.postConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */
    async putConsentGdprRaw(requestParameters: PutConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PutConsentGdpr200Response>> {
        if (requestParameters.gDPRConsentRequest === null || requestParameters.gDPRConsentRequest === undefined) {
            throw new runtime.RequiredError('gDPRConsentRequest','Required parameter requestParameters.gDPRConsentRequest was null or undefined when calling putConsentGdpr.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters.slashIDSdkVersion !== undefined && requestParameters.slashIDSdkVersion !== null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters.slashIDSdkVersion);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consent/gdpr`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: GDPRConsentRequestToJSON(requestParameters.gDPRConsentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PutConsentGdpr200ResponseFromJSON(jsonValue));
    }

    /**
     * Stores the GDPR consent levels and timestamp. Returns the consent levels and the timestamp at which the consent information was received. This will overwrite existing GDPR consent levels for the specified person. The consent levels indicate the types of data classes the person has allowed during their use of your services, in accordance with GDPR. 
     * Set GDPR consent of current user
     */
    async putConsentGdpr(requestParameters: PutConsentGdprRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PutConsentGdpr200Response> {
        const response = await this.putConsentGdprRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
